import PropTypes from 'prop-types'
import {Box, Text} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import Attention from './Attention'

const StatementNotificationAlert = ({payerName}) => {
  const {t} = useTranslation('payerStatements')

  return (
    <Attention>
      <Text textStyle="body-intro-medium">
        {t('bankAccountDetails.outsidePayments.title')}
      </Text>
      <Box display="flex" flexDirection={{base: 'column', md: 'row'}}>
        <Text textStyle="body-small">
          {t(
            'bankAccountDetails.outsidePayments.statementNotification.message',
            {
              payerName,
            },
          )}
        </Text>
      </Box>
    </Attention>
  )
}

StatementNotificationAlert.propTypes = {
  payerName: PropTypes.string.isRequired,
}

export default StatementNotificationAlert
